// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var AuthSession = require("./AuthSession.bs.js");

function SessionRenewer(props) {
  var authSession = AuthSession.use();
  var expiresAt = authSession !== undefined && authSession.__typename === "AuthSession" ? authSession.expiresAt : undefined;
  React.useEffect((function () {
          if (expiresAt === undefined) {
            return ;
          }
          var expiresIn = expiresAt - Date.now();
          var refreshSessionAt = Math.max(0, expiresIn - 5 * 60 * 1000);
          var intervalId = setInterval((function () {
                  AuthSession.createSession();
                }), refreshSessionAt);
          return (function () {
                    clearInterval(intervalId);
                  });
        }), [expiresAt]);
  return null;
}

var make = SessionRenewer;

exports.make = make;
/* react Not a pure module */
